export const general = {
  upload: {
    file_name: "File name",
    file_size: "File size",
    file_invalid_type: "File type must be {{messageSuffix}}",
    file_too_large: "File is larger than {{maxSize}}{{unit}}",
    file_too_small: "File is smaller than {{minSize}}{{unit}}",
    too_many_files: "Too many files, only {{maxFiles}} allowed",
    rejected_header: "Rejected files",
    release_drop: "Drag and drop file here",
    select_from_your_computer: "or select from your computer",
  },
  table: {
    reset_table_layout: "Reset table layout",
  },
  access_denied: "You do not have access to this page",
  assign_selected: "Assign selected",
  Link: "Link",
  similarity: {
    High: "High",
    Low: "Low",
    Medium: "Medium",
    Very_high: "Very high",
    Very_low: "Very low",
    score: "Similarity score",
  },
  show: "Show",
  hide: "Hide",
  this_action_cannot_be_undone: "This action cannot be undone",
  continue: "Continue",
  current: "Current",
  latest: "Latest",
  download_excel: "Download Excel",
  changes: "Changes",
  compare: "Compare",
  tenant_not_provided_for_current_user:
    "Tenant for current user not provided. Check view's (endpoint function) configuration.",
  overview: "Overview",
  only_paying_customers_can_access_this_feature: "Only paying customers can access this feature",
  add_file_url: "Add file url",
  add_file_URL_button: "Add file URL button",
  Alert: "Alert",
  All: "All",
  other: "Other",
  All_changes_have_been_saved: "All changes have been saved.",
  All_sub_themes: "All sub themes",
  All_themes: "All themes",
  Apply: "Apply",
  Approve: "Approve",
  are_you_sure: "Are you sure?",
  Assessment: "Assessment",
  Assessments: "Assessments",
  Back: "Back",
  Cancel: "Cancel",
  close: "Close",
  Clear_all: "Clear all",
  Collapse_all: "Collapse all",
  Companies: "Companies",
  Confirm: "Confirm",
  Dashboard: "Dashboard",
  Declined: "Declined",
  Delete: "Delete",
  Description: "Description",
  Deselect_all: "Deselect all",
  Documentation: "Documentation",
  Duplicate: "Duplicate",
  Edit: "Edit",
  Email: "Email",
  Error: "Error",
  Expand_all: "Expand all",
  File: "File",
  First_name: "First name",
  Help: "Help",
  hide_menu: "Hide menu",
  Important_Notice: "Important Notice",
  Incorrect_data: "Incorrect data",
  Job_title: "Job title",
  Last_update: "Last update",
  load_more: "load more",
  Next: "Next",
  No: "No",
  no_answer: "No answer",
  No_results: "No results",
  Notifications: "Notifications",
  Ok: "Ok",
  Open_settings: "Open settings",
  or: "or",
  Proceed: "Proceed",
  Protocol: "Protocol",
  Remove: "Remove",
  Reports: "Reports",
  Reset_to_default: "Reset to default",
  Reviewers: "Reviewers",
  Role: "Role",
  roles: {
    Data_provider: "Data provider",
    data_providers: "Data providers",
    reviewer: "reviewer",
    Reviewer: "Reviewer",
    Verifier: "Verifier",
  },
  Roles: "Roles",
  Row: "Row",
  Save: "Save",
  Saving: "Saving...",
  search: "search",
  Search: "Search",
  Search_bar: "Search bar",
  Select: "Select",
  Select_all: "Select all",
  show_menu: "Show menu",
  Show_more: "Show more",
  show_less: "Show less",
  Site: "Site",
  Site_creation: "Site creation",
  Site_edition: "Site edition",
  Sites: "Sites",
  Standard: "Standard",
  standards: "standards",
  SupportPortal: "Support Portal",
  Surname: "Surname",
  there_are_no_files: "There are no files.",
  This_field_is_required: "This field is required",
  "Type_name_surname_or_e-mail": "Type name, surname or e-mail",
  Type_search_text_here: "Type search text here",
  Type_to_search: "Type to search",
  Unsaved_Changes: "Unsaved Changes",
  Upload: "Upload",
  Url: "Url",
  Users: "Users",
  validation: {
    At_last_one_site_is_required: "At last one site is required",
    At_last_one_standard_is_required: "At last one standard is required",
    Coordinator_is_required: "Coordinator is required",
    Country_is_required: "Country is required",
    Email_is_used_in_another_company: "Email is used in another company",
    Incorrect_email: "Incorrect email",
    name_is_required: "Name is required.",
    Scope_of_applicability_is_required: "Scope of applicability is required",
    site_is_required: "Site is required.",
    this_field_is_required: "This field is required.",
    This_field_must_be_unique: "This field must be unique.",
  },
  Yes: "Yes",
  You_have_unsaved_changes_Are_you_sure_you_want_to_leave: "You have unsaved changes. Are you sure you want to leave?",
  ai_disclaimer: {
    title: "AI Translation Notice",
    message:
      "This translation of the protocol questions and standard requirements was generated using artificial intelligence tools and may contain inaccuracies.",
    accept: "I Understand",
    go_back: "Go Back",
    switch_to_english: "Switch to English",
  },
} as const;
